import { useId } from "react"

/** Булавка с видеокамерой. Кнопка позиционирования камеры в 3D-сцене. */
export function CameraPlaceIcon({ className }: { className?: string }) {
  const maskId = `camera-place${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`

  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      width="24"
      height="24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="white" stroke="none" />
        <rect x="9.6" y="9.2" width="8.12" height="6.96" rx="1.16" fill="black" stroke="none" />
        <path d="M16.9 11.29 21.2 9.78v5.8l-4.3-1.51Z" fill="black" stroke="none" />
      </mask>
      <path
        mask={`url(#${maskId})`}
        d="M8.4 2.2C11.5 2.2 14 4.6 14 7.6 14 11.4 8.4 21.4 8.4 21.4S2.8 11.4 2.8 7.6C2.8 4.6 5.3 2.2 8.4 2.2Z"
      />
      <rect x="9.6" y="9.2" width="8.12" height="6.96" rx="1.16" />
      <path d="M17.72 11.29 21.2 9.78v5.8l-3.48-1.51Z" />
    </svg>
  )
}
